<template>
	<b-container fluid>
		<page-title><h2 v-if="item">Dane firmy/Edycja</h2></page-title>

		<div class="col page-element">
			<alert-loading v-if="retrieveLoading || updateLoading"></alert-loading>
			<div v-if="retrieveError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ retrieveError }}</div>
			<div v-if="updateError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ updateError }}</div>

			<CompanyForm v-if="item && !retrieveLoading && !updateLoading" :handle-submit="update" :values="item" :errors="violations" :initialValues="retrieved"></CompanyForm>
		</div>
	</b-container>
</template>

<script>
  import CompanyForm from './Form.vue';
  import { mapGetters } from 'vuex';

  export default {
    created () {
      this.$store.dispatch('company/update/retrieve', this.configCompany.id);
    },
    components: {
      CompanyForm
    },
    computed: {
      ...mapGetters({
        retrieveError: 'company/update/retrieveError',
        retrieveLoading: 'company/update/retrieveLoading',
        updateError: 'company/update/updateError',
        updateLoading: 'company/update/updateLoading',
        retrieved: 'company/update/retrieved',
        updated: 'company/update/updated',
        violations: 'company/update/violations',
        configCompany: 'config/config/company',
      })
    },
    data: function() {
      return {
        item: {}
      }
    },
    methods: {
      update (values) {
        this.$store.dispatch('company/update/update', {item: this.retrieved, values: values });
      }
    },
	watch:{
      updated(data){
        if (data) {
          this.$router.push({ name: 'CompanyShow'});
        }
	  }
	}
  }
</script>



// WEBPACK FOOTER //
// Update.vue?00614820